import moment from "moment-timezone";
export const getDate7DaysAgo = (date = new Date()) => {
  const taskDate = new Date(date);
  const today = new Date();
  const difference = today.getTime() - taskDate.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
};

const formatDate = ({ value, format, timezone }) => {
  const dayTz = moment(value).tz(timezone);
  return dayTz.format(format);
};

export const getDateLabel = ({ startsAt = null, endsAt = null, timezone }) => {
  const dateExists = startsAt && endsAt;
  let dateLabel = null;

  if (dateExists) {
    const dateFrom = moment(startsAt);
    const dateTo = moment(endsAt);
    const isSameDate = dateFrom.isSame(dateTo, "day");

    const formattedStartDatestamp = formatDate({
      value: startsAt,
      format: `ddd, MMM Do, h:mma`,
      timezone
    });

    const formattedEndDatestamp = formatDate({
      value: endsAt,
      // @NOTE: The commented timeline includes timezone if we ever want to include it
      // format: isSameDate ? 'h:mma zz(Z)' : `ddd, MMM Do, h:mma zz(Z)`,
      format: isSameDate ? "h:mma" : `ddd, MMM Do, h:mma`,
      timezone
    });

    dateLabel = `${formattedStartDatestamp} - ${formattedEndDatestamp}`;
  }
  return dateLabel;
};
